<!-- category-header -->

<header class="category-header" *ngIf="headerStyle == 'category'">
  <div
    class="container h-100 overflow-visible px-0 mobile-category-header-padding"
  >
    <div class="row m-0 h-100">
      <div class="col-sm-12 m-0 px-0">
        <h1 class="h-100 text-left center">
          <div>
            <a [routerLink]="['/category']" class="title"> CitizeX Admin </a>
          </div>
          <div class="dropdown dropdown-img menu center navigation-menu">
            <button
              class="btn dropdown-toggle btn-img-circle fix-avtar-2-5"
              type="button"
              id="dropdownMenu"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <img
                src="../../../../assets/images/noprofile2.png"
                alt="Profile Image"
              />
            </button>
            <div
              class="dropdown-menu dropdown-menu-right mr-0 shadow"
              aria-labelledby="dropdownMenuButton"
            >
              <button
                type="button"
                class="close btn btn-link btn-tbl-link-danger"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                data-target=".navigation-menu"
              >
                <i class="fi flaticon-cancel"></i>
              </button>
              <div
                class="text-center px-3 py-2"
                (click)="$event.stopPropagation()"
              >
                <button
                  [routerLink]="[
                    '/profile/view-profile/',
                    defaultProfile.tagName
                  ]"
                  (click)="$event.stopPropagation()"
                  class="btn btn-img-circle fix-avtar-4 my-1 mx-auto"
                >
                  <img
                    *ngIf="
                      defaultProfile.profileImage == '' ||
                      defaultProfile.profileImage == null
                    "
                    src="../../../../assets/images/noprofile2.png"
                    alt="Profile Image"
                  />
                  <img
                    *ngIf="
                      defaultProfile.profileImage != '' &&
                      defaultProfile.profileImage != null
                    "
                    [src]="defaultProfile.profileImage"
                    onerror="this.src='../../../assets/images/noprofile2.png';"
                    alt="Profile Image"
                  />
                </button>
                <h4 class="p-1">
                  {{ nonVerifiedUser.firstName }} {{ nonVerifiedUser.lastName }}
                </h4>
                <h6 class="p-1">&#64;{{ nonVerifiedUser.userName }}</h6>
              </div>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" [routerLink]="['/category']"
                ><i class="fi flaticon-list"></i> Category</a
              >
              <a class="dropdown-item" [routerLink]="['/category/addCategory']"
                ><i class="fi flaticon-plus"></i> Add Category</a
              >
              <a class="dropdown-item" [routerLink]="['/deduplication']"
                ><i class="fi flaticon-plus"></i> Deduplication</a
              >
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" [routerLink]="['/spam-reports']"
                ><img
                  src="../../../assets/images/spam-report.svg"
                  class="spam-img"
                />
                Spam Reports</a
              >
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" [routerLink]="['/verify-profiles']"
                ><i class="fi flaticon-user"></i> User Profiles</a
              >
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" [routerLink]="['/claim-request']"
                ><i class="fi flaticon-information"></i> Claim Request</a
              >
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" [routerLink]="['/dashboard']"
                ><img
                  src="../../../../assets/images/Admin-dashboard-img.svg"
                  class="dashboard-img"
                />
                Dashboard
              </a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" (click)="logOut()"
                ><i class="fi flaticon-logout"></i> Logout</a
              >
              <!-- <div class="dropdown-divider"></div>
              <a class="dropdown-item" (click)="logOut()"><i class="fi flaticon-logout"></i> Logout</a> -->
            </div>
          </div>
        </h1>
      </div>
    </div>
  </div>
</header>
<!-- category-header Ends-->

<header
  class="{{ headerStyle }}-header d-none"
  *ngIf="headerStyle == 'homepage'"
>
  <nav class="navbar navbar-expand-sm py-0 minh-100">
    <ul class="nav nav-pills nav-fill">
      <li class="nav-item active" *ngIf="this.loginBtn == false">
        <a
          class="nav-link"
          href="#"
          name="aboutUs"
          id="aboutUs"
          data-toggle="modal"
          (click)="aboutus()"
        >
          <button class="btn btn-black py-sm-1 px-sm-3 font-14 about-us-btn">
            About Us
          </button></a
        >
      </li>
    </ul>
    <button
      *ngIf="this.logoutBtn === true"
      (click)="navigate()"
      class="navbar-toggler ml-auto btn btn-black mw-auto"
      data-toggle="modal"
      id="postReview"
      name="postReview"
      type="button"
    >
      Login / Sign Up
    </button>
    <div class="d-flex col px-0 d-md-none" *ngIf="this.logoutBtn !== true">
      <!-- <a class="nav-link icon-hover col px-0 justify-content-center mobile-feedback"
        *ngIf="this.loginBtn == true && isHomepage" (click)="openFeedbackModal()">
        <span class="nav-text font-16 fw-600">Have feedback?</span></a> -->
      <button
        class="navbar-toggler ml-auto"
        type="button"
        data-toggle="collapse"
        data-target="#navbarNavDropdown"
        aria-controls="navbarNavDropdown"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <i class="fi flaticon-menu-square font-24"></i>
      </button>
    </div>
    <div class="collapse navbar-collapse" id="navbarNavDropdown">
      <ul class="nav nav-pills nav-fill">
        <li class="nav-item active" *ngIf="this.loginBtn == true">
          <a
            class="nav-link"
            href="#"
            name="aboutUs"
            id="aboutUs"
            data-toggle="modal"
            (click)="aboutus()"
          >
            <button class="btn btn-black py-1 px-sm-2 px-3 font-14">
              About Us
            </button>
          </a>
        </li>
      </ul>
      <!-- <ul class="nav nav-pills nav-fill m-auto header-icons feedback-nav-pills d-md-block d-none"
        *ngIf="this.loginBtn == true && isHomepage"
        [ngClass]="{ 'header-feedback':  user.defaultProfileId == null,'notification-alert' : !verified }">
        <li class="nav-item active" (click)="openFeedbackModal()">
          <a class="nav-link icon-hover">
            <span class="nav-text font-16 fw-600">Have feedback?</span></a>
        </li>
      </ul> -->
      <ul
        class="nav nav-pills nav-fill ml-auto p-3 p-sm-0 header-icons"
        [ngClass]="{ 'ml-lg-auto': logoutBtn }"
      >
        <li class="nav-item active" *ngIf="verified">
          <a
            class="nav-link icon-hover"
            name="postReview"
            id="newPostReviewMobile"
            data-toggle="modal"
            (click)="checkLogin()"
            ><i class="fi flaticon-content font-24"></i>
            <span class="nav-text fw-600 font-16">New Post</span></a
          >
        </li>
        <li
          class="nav-item active"
          *ngIf="this.user !== null && this.user.defaultProfileId !== null"
        >
          <a
            class="nav-link icon-hover"
            [routerLink]="['/profile/view-profile/', defaultProfile.tagName]"
            ><i class="fi flaticon-user font-24"></i>
            <span class="nav-text font-16 fw-600">Your Page</span></a
          >
        </li>
        <!-- <li title="Verification status" class="nav-item" *ngIf="this.loginBtn == true">
          <a class="nav-link" [routerLink]="['/signup']"><i *ngIf="verified == false"
              class="fi flaticon-shield-failed font-danger font-24"></i><i *ngIf="verified == true"
              class="fi flaticon-shield-success font-success font-24"></i>
            <span class="nav-text font-16 fw-600">Verification status</span></a>
        </li> -->

        <!-- <li title="Create a page" class="nav-item" *ngIf="
            verified && this.loginBtn == true && user.reviewProfileId == null
          ">
          <a class="nav-link" (click)="openCreatePageModal()"><i class="fi flaticon-user-add font-24"></i>
            <span class="nav-text font-16 fw-600">Create a page</span></a>
        </li> -->
        <!-- <li title="Your pages" class="nav-item" *ngIf="verified && this.loginBtn == true"
          [ngClass]="{ 'd-none': user.defaultProfileId == null }">
          <a class="nav-link" *ngIf="defaultProfile.profileName !== null"
            [routerLink]="['/profile/list-own-profiles']"><i class="fi flaticon-user-pencil font-24"></i>
            <span class="nav-text font-16 fw-600">Your pages</span></a>
        </li> -->

        <!-- homepage notification start -->
        <li
          class="nav-item dropdown dropdown-img navigation-menu-notify notification-main"
          *ngIf="this.user !== null"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <!-- <a class="nav-link" [routerLink]="['/search']"><i class="fi flaticon-notification font-24"></i></a> -->
          <a
            class="nav-link dropdown-toggle icon-hover"
            role="button"
            id="dropdownMenuLink"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            (click)="getNotifications()"
          >
            <i class="fi flaticon-notification font-24">
              <span
                class="badge"
                *ngIf="notificationCount > 0 && notificationCount < 10"
              >
                {{ notificationCount }}
              </span>
              <span class="badge1" *ngIf="notificationCount >= 10">
                9 <span class="formore">+</span></span
              >
            </i>
            <span class="nav-text font-16 fw-600">Alerts</span>
          </a>

          <div
            class="dropdown-menu dropdown-menu-right mr-0 shadow notification-dropdown"
            aria-labelledby="dropdownMenuLink"
          >
            <div class="Notify-header d-none">
              <p class="text-center h6 my-2">Notifications</p>
              <button
                type="button"
                class="close btn btn-link btn-tbl-link-danger"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                data-target=".notification-main"
              >
                <i class="fi flaticon-cancel"></i>
              </button>
            </div>
            <div
              class="notification-inner-main main-height"
              (scroll)="onScroll($event)"
            >
              <div class="notification-scroll">
                <a
                  class="dropdown-item notification-changes px-2 pb-2 pt-1"
                  *ngFor="let notification of notificationList"
                  (click)="$event.stopPropagation()"
                  [ngClass]="{ unread: !notification.isRead }"
                >
                  <div class="col-12 row m-0 px-0 notification-mobile-custom">
                    <div class="col-md-auto col-2 pl-0 pr-1 pt-2">
                      <a
                        class="nav-link btn dropdown-toggle btn-img-circle fix-avtar-3 mx-auto"
                        [routerLink]="[
                          '/profile/view-profile',
                          notification.byProfileTagName
                        ]"
                        (click)="$event.stopPropagation()"
                        id="dropdownMenuButton"
                        role="button"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        <img
                          *ngIf="
                            notification.byProfileImage == '' ||
                            notification.byProfileImage == null
                          "
                          src="../../../../assets/images/noprofile2.png"
                          alt="Profile Image"
                        />
                        <img
                          *ngIf="
                            notification.byProfileImage != '' &&
                            notification.byProfileImage != null
                          "
                          [src]="notification.byProfileImage"
                          onerror="this.src='../../../assets/images/noprofile2.png';"
                          alt="Profile Image"
                        />
                      </a>
                    </div>
                    <div
                      class="col-md-9 px-0 pl-2"
                      (click)="updateNotification(notification)"
                      (click)="$event.stopPropagation()"
                    >
                      <div class="lh-3-15 font-12">
                        <span class="h6 font-12 text-theme"
                          >{{ notification.byProfileName }} &nbsp;</span
                        >
                        <span class="font-gray font-12"
                          >({{ notification.byProfileTagName }}) &nbsp;</span
                        >
                        <span
                          class="font-gray font-12 ml-1"
                          *ngIf="
                            notification.notification_type !== 'ANNOUNCEMENT' &&
                            notification.notification_type !==
                              'VIRTUAL_EVENT' &&
                            notification.notification_type !== 'NEW_POST' &&
                            notification.notification_type !== 'NEW_POLL'
                          "
                        >
                          {{
                            notification.notification_type === 'MENTION'
                              ? 'mentioned you:'
                              : 'replied:'
                          }}</span
                        >
                        <span
                          class="font-gray font-12"
                          *ngIf="
                            notification.notification_type === 'VIRTUAL_EVENT'
                          "
                        >
                          created a virtual event:</span
                        >
                        <span
                          class="font-gray font-12"
                          *ngIf="notification.notification_type === 'NEW_POST'"
                        >
                          added a new post:</span
                        >
                        <span
                          class="font-gray font-12"
                          *ngIf="notification.notification_type === 'NEW_POLL'"
                        >
                          added a new poll:</span
                        >
                        <p
                          class="font-gray font-12"
                          *ngIf="
                            notification.notification_type === 'ANNOUNCEMENT'
                          "
                        >
                          {{
                            notification.notification_type === 'ANNOUNCEMENT'
                              ? 'posted announcement:'
                              : ''
                          }}
                        </p>

                        <p
                          class="text-theme font-12 notification-text"
                          *ngIf="
                            notification.notification_type !== 'ANNOUNCEMENT' &&
                            notification.notification_type !== 'VIRTUAL_EVENT'
                          "
                          [innerHTML]="
                            notification.content
                              | applinkifyHtml : { limit: true, limitChars: 20 }
                          "
                        ></p>

                        <p
                          class="text-theme font-12 notification-text"
                          *ngIf="
                            notification.notification_type == 'ANNOUNCEMENT'
                          "
                          [innerHTML]="
                            notification.announcementHeading
                              | applinkifyHtml : { limit: true, limitChars: 20 }
                          "
                        ></p>

                        <p
                          class="text-theme font-12 notification-text"
                          *ngIf="
                            notification.notification_type == 'VIRTUAL_EVENT'
                          "
                          [innerHTML]="
                            notification.virtualEventTitle
                              | applinkifyHtml : { limit: true, limitChars: 20 }
                          "
                        ></p>
                      </div>
                      <div
                        *ngIf="
                          todayDate === notification.createdDate.substr(0, 10)
                        "
                        class="font-gray font-12"
                      >
                        {{ notification.daysAgo }}
                      </div>

                      <div
                        *ngIf="
                          todayDate != notification.createdDate.substr(0, 10)
                        "
                        class="font-gray font-12"
                      >
                        {{
                          notification.createdDate | date : 'MMM d, y' : 'UTC'
                        }}
                      </div>
                    </div>
                    <div
                      class="col-1 d-flex align-items-center justify-content-end px-0"
                    >
                      <img
                        src="../../../../assets/images/cross_img.svg"
                        class="cursor-pointer"
                        (click)="deleteNotification(notification.id, $event)"
                      />
                    </div>
                  </div>
                </a>
                <a
                  class="dropdown-item notification-changes px-2 py-3 last-notification mb-0 notification-message"
                  *ngIf="notificationList.length == 0"
                >
                  <div class="col-12 row m-0 px-0 notification-mobile-custom">
                    <!-- <div class="col-md-auto col-2 pl-0 pr-1 pt-sm-1">
                      <a class="nav-link btn dropdown-toggle btn-img-circle fix-avtar-3 mx-auto fixed-link"
                        id="dropdownMenuButton" role="button" data-toggle="dropdown" aria-haspopup="true"
                        aria-expanded="false">
                        <img src="../../../../assets/images/new-logo-text.png" alt="Profile Image" />
                      </a>
                    </div> -->
                    <div
                      class="col-12 px-0 d-flex align-items-center justify-content-center"
                    >
                      <div>
                        <!-- <p class="h6 font-14 text-theme">Welcome to CitizeX</p>
                        <p class="font-gray font-12">
                          Hi {{ user.firstName }} ! Welcome to CitizeX. Complete
                          your verification in easy step.
                        </p> -->
                        <p class="font-16 text-theme fw-600">No Notification</p>
                      </div>
                      <!-- <img src="../../../../assets/images/cross_img.svg" class="cursor-pointer"> -->
                    </div>
                  </div>
                </a>
              </div>
              <div
                class="dropdown-item btn-link btn-link-theme text-center p-1 cursor-pointer"
                (click)="deleteNotification()"
                *ngIf="notificationList.length > 0"
              >
                Clear All
              </div>
            </div>
          </div>
        </li>
        <!-- homepage notification end -->

        <li class="nav-item mx-0">
          <button
            *ngIf="this.logoutBtn == true"
            (click)="navigate()"
            class="btn btn-black"
            data-toggle="modal"
            id="postReview"
            name="postReview"
            type="button"
          >
            Login / Sign Up
          </button>
        </li>
        <li
          *ngIf="this.loginBtn == true"
          class="nav-item dropdown dropdown-img navigation-menu"
        >
          <a
            class="nav-link btn dropdown-toggle btn-img-circle fix-avtar-2-5 mx-auto"
            href="#"
            id="dropdownmenu"
            role="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <img
              *ngIf="
                defaultProfile.profileImage == '' ||
                defaultProfile.profileImage == null
              "
              src=".././../../assets/images/noprofile2.png"
              alt="Profile Image"
            />

            <img
              *ngIf="
                defaultProfile.profileImage != '' &&
                defaultProfile.profileImage != null
              "
              [src]="defaultProfile.profileImage"
              onerror="this.src='../../../assets/images/noprofile2.png';"
              alt="Profile Image"
            />
          </a>
          <div
            class="dropdown-menu mobile-dropdown dropdown-scroll dropdown-menu-right mr-0 shadow"
            aria-labelledby="dropdownMenuButton"
          >
            <button
              type="button"
              class="close btn btn-link btn-tbl-link-danger"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              data-target=".navigation-menu"
            >
              <i class="fi flaticon-cancel"></i>
            </button>
            <div
              class="text-center px-3 py-lg-2 py-sm-1"
              (click)="$event.stopPropagation()"
            >
              <button
                *ngIf="defaultProfile.profileName != null"
                [routerLink]="[
                  '/profile/view-profile/',
                  defaultProfile.tagName
                ]"
                (click)="$event.stopPropagation()"
                class="btn btn-img-circle fix-avtar-4 my-1 mx-auto"
              >
                <img
                  *ngIf="
                    defaultProfile.profileImage == '' ||
                    defaultProfile.profileImage == null
                  "
                  src="../../../../assets/images/noprofile2.png"
                  alt="Profile Image"
                />
                <img
                  *ngIf="
                    defaultProfile.profileImage != '' &&
                    defaultProfile.profileImage != null
                  "
                  [src]="defaultProfile.profileImage"
                  onerror="this.src='../../../assets/images/noprofile2.png';"
                  alt="Profile Image"
                />
              </button>
              <button
                *ngIf="defaultProfile.profileName == null"
                (click)="$event.stopPropagation()"
                class="btn btn-img-circle fix-avtar-4 my-1 mx-auto"
              >
                <img
                  *ngIf="
                    defaultProfile.profileImage == '' ||
                    defaultProfile.profileImage == null
                  "
                  src="../../../../assets/images/noprofile2.png"
                  alt="Profile Image"
                />
                <img
                  *ngIf="
                    defaultProfile.profileImage != '' &&
                    defaultProfile.profileImage != null
                  "
                  [src]="defaultProfile.profileImage"
                  onerror="this.src='../../../assets/images/noprofile2.png';"
                  alt="Profile Image"
                />
              </button>
              <h4 class="p-1" *ngIf="!verified">
                {{ nonVerifiedUser.firstName }} {{ nonVerifiedUser.lastName }}
              </h4>
              <h6 class="p-1" *ngIf="!verified">
                &#64;{{ nonVerifiedUser.userName }}
              </h6>
              <h4
                class="p-1"
                *ngIf="verified && defaultProfile.publicName == null"
              >
                {{ nonVerifiedUser.firstName }} {{ nonVerifiedUser.lastName }}
              </h4>
              <h6
                class="p-1"
                *ngIf="verified && defaultProfile.publicName == null"
              >
                &#64;{{ nonVerifiedUser.userName }}
              </h6>
              <h4
                class="p-1"
                *ngIf="verified && defaultProfile.publicName !== null"
              >
                {{ defaultProfile.publicName }}
              </h4>
              <h6
                class="p-1"
                *ngIf="verified && defaultProfile.publicName !== null"
              >
                &#64;{{ defaultProfile.tagName }}
              </h6>
              <a
                *ngIf="defaultProfile.id != null"
                class="btn btn-underline font-16"
                [routerLink]="['/profile/edit-profile/', defaultProfile.id]"
                (click)="closeNavbarCollepse()"
                ><i class="fi flaticon-edit"></i> Edit</a
              >
            </div>
            <div class="dropdown-divider"></div>
            <!-- <a class="btn dropdown-item pointer" [routerLink]="['/profile/edit-profile/', defaultProfile.id]"><i class="fi flaticon-logout"></i> Edit</a> -->
            <a
              class="btn dropdown-item pointer"
              [routerLink]="['/profile/block-profile/']"
              (click)="closeNavbarCollepse()"
              ><i class="fi flaticon-user-remove fw-600"></i> Blocked
              Profiles</a
            >
            <div class="dropdown-divider" *ngIf="verified == false"></div>
            <div
              class="extra"
              (click)="$event.stopPropagation()"
              *ngIf="verified == false"
            ></div>
            <!-- <div class="extra" (click)="$event.stopPropagation()"></div>
            <a class="btn dropdown-item pointer" (click)="openCreatePageModal()"
              *ngIf="verified && this.loginBtn == true && user.reviewProfileId == null"><i class="fi flaticon-user-add fw-600"></i>
              <span class="ml-sm-1">Create a page</span></a>
            <div class="dropdown-divider"></div> -->
            <a
              class="btn dropdown-item pointer dropdown-icon"
              [routerLink]="['/signup']"
              *ngIf="verified == false"
              (click)="closeNavbarCollepse()"
              ><i
                *ngIf="verified == false"
                class="fi flaticon-shield-failed font-danger fw-600"
              ></i>
              <!--   <i *ngIf="verified == true" class="fi flaticon-shield-success font-success fw-600"></i> -->
              <span class="ml-sm-1">Verification status</span></a
            >
            <!-- <div class="dropdown-divider" *ngIf="verified == false"></div>
            <div class="extra" (click)="$event.stopPropagation()"></div>
            <a class="btn dropdown-item pointer" *ngIf="defaultProfile.profileName !== null && verified && this.loginBtn == true"
              [ngClass]="{ 'd-none': user.defaultProfileId == null }" [routerLink]="['/profile/list-own-profiles']"><i
                class="fi flaticon-user-pencil fw-600"></i>
              <span class="ml-sm-1">Your pages</span></a> -->
            <div class="dropdown-divider" *ngIf="verified == false"></div>
            <a
              class="btn dropdown-item pointer"
              (click)="goToReportAbuse($event)"
              ><i class="fi flaticon-warning fw-600"></i> Report an Abuse</a
            >
            <div class="dropdown-divider"></div>
            <div
              class="have-feedback d-flex align-items-center dropdown-icon"
              (click)="openFeedbackModal()"
            >
              <img
                src="../../../../assets/images/feedback-img.svg"
                alt="have feedback"
                class="profile-icons"
              />
              <a class="btn dropdown-item pointer ml-sm-1"> Have feedback?</a>
            </div>
            <div class="dropdown-divider"></div>
            <div
              class="extra"
              (click)="$event.stopPropagation()"
              *ngIf="verified"
            ></div>
            <a
              class="btn dropdown-item pointer dropdown-icon"
              *ngIf="verified"
              (click)="Updateaddress()"
              ><i class="fi flaticon-edit fw-600"></i> Update my address</a
            >
            <div
              class="extra"
              (click)="$event.stopPropagation()"
              *ngIf="verified"
            ></div>
            <div class="dropdown-divider" *ngIf="verified"></div>
            <!-- <a class="btn dropdown-item pointer dropdown-icon" (click)="phonoModal()">
            Update Phone no </a> -->
            <div
              class="have-feedback d-flex align-items-center dropdown-icon"
              (click)="phonoModal()"
              *ngIf="verified"
            >
              <img
                src="../../../../assets/images/update-phone-no.svg"
                class="profile-icons edit-img"
              />
              <a class="btn dropdown-item pointer ml-sm-1 p-0"
                >Update Phone no</a
              >
            </div>
            <div
              class="extra"
              (click)="$event.stopPropagation()"
              *ngIf="verified"
            ></div>
            <div class="dropdown-divider" *ngIf="verified"></div>
            <!-- <a class="btn dropdown-item pointer dropdown-icon" (click)="updateemail()"><i
              class="fi flaticon-edit fw-600 "></i>
            Update my email</a> -->
            <div
              class="have-feedback d-flex align-items-center dropdown-icon"
              (click)="updateemail()"
              *ngIf="verified"
            >
              <img
                src="../../../../assets/images/update-email.svg"
                class="profile-icons edit-img"
              />
              <a class="btn dropdown-item pointer ml-sm-1 p-0">Update Email</a>
            </div>
            <div
              class="extra"
              (click)="$event.stopPropagation()"
              *ngIf="verified && user.defaultProfileId != null"
            ></div>
            <div
              class="dropdown-divider"
              *ngIf="verified && user.defaultProfileId != null"
            ></div>
            <div
              class="have-feedback d-flex align-items-center dropdown-icon"
              (click)="nameSettingModal()"
              *ngIf="verified && user.defaultProfileId != null"
            >
              <img
                src="../../../../assets/images/name-setting-img.svg"
                class="profile-icons edit-img"
              />
              <a class="btn dropdown-item pointer ml-sm-1 p-0">Name Setting</a>
            </div>
            <div
              class="extra"
              (click)="$event.stopPropagation()"
              *ngIf="verified"
            ></div>
            <div class="dropdown-divider" *ngIf="verified"></div>
            <div
              class="have-feedback email-notification-row d-flex align-items-center dropdown-icon"
              (click)="$event.stopPropagation()"
            >
              <i
                class="fi flaticon-notification profile-icons edit-img fw-600"
              ></i>

              <a
                class="btn dropdown-item pointer email-notification-label ml-sm-1 p-0"
                style="white-space: nowrap"
              >
                Email Notifications
              </a>

              <label class="switch mb-0 ml-auto mr-1" style="flex-shrink: 0">
                <input
                  type="checkbox"
                  [(ngModel)]="emailNotificationsEnabled"
                  [ngModelOptions]="{ standalone: true }"
                  (ngModelChange)="updateEmailNotifications($event)"
                  (click)="$event.stopPropagation()"
                />
                <span class="slider round"></span>
              </label>
            </div>
            <div class="dropdown-divider"></div>
            <a class="btn dropdown-item pointer" (click)="logOut()"
              ><i class="fi flaticon-logout fw-600"></i> Logout</a
            >
            <div class="extra" (click)="$event.stopPropagation()"></div>
            <div class="dropdown-divider"></div>
            <!-- <a class="btn dropdown-item pointer" [routerLink]="['/profile/edit-profile/', defaultProfile.id]"><i class="fi flaticon-logout"></i> Edit</a> -->
            <a
              class="btn dropdown-item pointer dropdown-icon"
              [routerLink]="['/deleteAccount']"
              (click)="closeNavbarCollepse()"
              ><i class="fi flaticon-delete fw-600"></i> Delete Account</a
            >
          </div>
        </li>
      </ul>
    </div>
  </nav>
  <a
    class="extra-header"
    data-toggle="collapse"
    data-target="#navbarNavDropdown"
    aria-controls="navbarNavDropdown"
    aria-expanded="false"
    aria-label="Toggle navigation"
  ></a>
</header>

<app-post-review-model></app-post-review-model>

<header
  class="{{ headerStyle }}-header"
  *ngIf="
    headerStyle == 'profile' ||
    headerStyle == 'firstLogin' ||
    headerStyle == 'homepage'
  "
>
  <nav class="navbar navbar-expand-md py-0 minh-100">
    <div class="col-auto">
      <a
        [routerLink]="['/homepage']"
        class="navbar-brand btn btn-img-no-effect h-40px d-block border-0"
        (click)="navigateToHome($event)"
      >
        <img
          src="../../../../assets/images/logo-text.png"
          class=""
          alt="Logo Image"
        />
      </a>
    </div>
    <div class="col p-0">
      <form
        class="col-12 col-xl-8 pl-0 ml-lg-auto header-search"
        *ngIf="headerStyle == 'profile' || headerStyle == 'homepage'"
      >
        <button
          type="button"
          class="btn btn-no-change search-sm bold d-sm-none d-block"
          (click)="searchOpen()"
        >
          <i class="fi flaticon-search"></i>
        </button>
        <div class="search-field">
          <div class="d-flex homepage-search header-search-custom">
            <!-- <input type="text" name="search" id="search" placeholder="Search profiles to review..." [(ngModel)]="searchValue" #searchString class="form-control search-input">
            -->
            <!-- <div class="ng-autocomplete w-100">
              <ng-autocomplete [data]="searchSuggetionList" name="searchValue" [initialValue]="searchValue"
                class="w-100" [searchKeyword]="'tagName'" (selected)="searchSelect($event)"
                (inputChanged)="onChangeSearch($event)" [itemTemplate]="itemTemplate" [minQueryLength]="1"
                (focus)="onFocus($event)" placeholder="Search an Individual..." (keydown.enter)="onEnter($event)">
              </ng-autocomplete>
              <ng-template #itemTemplate let-item class="dropdown-menu search-dropdown">
                <a [innerHTML]="item.displayName"></a>
              </ng-template>
            </div> -->
            <div class="search-container">
              <input
                id="searchAutocomplete"
                type="text"
                class="form-control"
                placeholder="Search for elected officials and CitizeX users"
                [(ngModel)]="searchValue"
                (input)="onChangeSearch(searchValue)"
                (keydown.enter)="onEnter($event)"
                (focus)="onFocus()"
                (blur)="onBlur()"
                autocomplete="off"
                name="searchValue"
              />

              <div
                class="suggestions"
                *ngIf="showSuggestions && searchSuggetionList.length > 0"
              >
                <!-- <h4 *ngIf="recentFirst" class="recent font-16 text-left px-3 py-2 fw-600">Recent</h4> -->
                <div
                  *ngFor="let item of searchSuggetionList"
                  (click)="searchSelect(item)"
                  class="suggestion-item"
                >
                  <span [innerHTML]="item.displayName"></span>
                </div>
              </div>
            </div>
          </div>
          <div class="extra" (click)="searchClose()"></div>
        </div>
      </form>
    </div>
    <div
      class="d-flex col-auto d-md-none justify-content-end"
      *ngIf="this.logoutBtn !== true"
    >
      <!-- <a class="nav-link icon-hover col px-0 justify-content-center mobile-feedback"
        *ngIf="this.loginBtn == true && isHomepage" (click)="openFeedbackModal()">
        <span class="nav-text font-16 fw-600">Have feedback?</span></a> -->

      <button
        class="navbar-toggler nav-link"
        type="button"
        data-toggle="collapse"
        data-target="#mainMenuCollapse"
        aria-controls="navbarNavDropdown"
        aria-expanded="false"
        aria-label="Toggle navigation"
        (click)="toggleMenu()"
        [ngClass]="{ show: !isMenuOpen }"
      >
        <i class="fi flaticon-menu-square font-24"></i>
      </button>
    </div>
    <a
      class="nav-link mr-3"
      href="#"
      name="aboutUs"
      id="aboutUs"
      data-toggle="modal"
      (click)="aboutus()"
      *ngIf="this.logoutBtn === true"
    >
      <button class="btn btn-black py-1 px-3 font-14">About Us</button>
    </a>
    <button
      *ngIf="this.logoutBtn === true"
      (click)="navigate()"
      class="btn btn-black ml-auto mw-auto"
      data-toggle="modal"
      id="postReview"
      name="postReview"
      type="button"
    >
      Login / Sign Up
    </button>
    <div class="col-12 col-md-auto px-0">
      <div class="collapse navbar-collapse w-auto" id="mainMenuCollapse">
        <ul class="nav nav-pills nav-fill">
          <li class="nav-item active" *ngIf="this.loginBtn == true">
            <a
              class="nav-link"
              href="#"
              name="aboutUs"
              id="aboutUs"
              data-toggle="modal"
              (click)="aboutus()"
            >
              <button class="btn btn-black py-1 px-sm-2 px-3 font-14">
                About Us
              </button></a
            >
          </li>
        </ul>
        <!-- <ul class="nav nav-pills nav-fill m-auto header-icons feedback-nav-pills d-md-block d-none"
          *ngIf="this.loginBtn == true && isHomepage" [ngClass]="{ 'header-feedback':  user.defaultProfileId == null }">
          <li class="nav-item active" (click)="openFeedbackModal()">
            <a class="nav-link icon-hover">
              
              <span class="nav-text font-16 fw-600">Have feedback?</span></a>
          </li>
        </ul> -->
        <ul class="nav nav-pills nav-fill p-3 p-sm-0 header-icons">
          <li class="nav-item active" *ngIf="verified">
            <a
              class="nav-link icon-hover"
              name="postReview"
              id="newPostReview"
              data-toggle="modal"
              (click)="checkLogin()"
              ><i class="fi flaticon-content font-24"></i>
              <span class="nav-text font-16 fw-600">New Post</span></a
            >
          </li>
          <li
            class="nav-item active"
            *ngIf="this.user !== null && this.user.defaultProfileId !== null"
          >
            <a
              class="nav-link icon-hover"
              id="yourPageId"
              [routerLink]="['/profile/view-profile/', defaultProfile.tagName]"
              (click)="yourPage()"
              ><i class="fi flaticon-user font-24"></i>
              <span class="nav-text font-16 fw-600">Your Page</span></a
            >
          </li>
          <!-- <li title="Verification status" class="nav-item" *ngIf="this.loginBtn == true ">
            <a class="nav-link" [routerLink]="['/signup']"><i *ngIf="verified == false"
                class="fi flaticon-shield-failed font-danger font-24"></i><i *ngIf="verified == true"
                class="fi flaticon-shield-success font-success font-24"></i>
              <span class="nav-text font-16 fw-600">Verification status</span></a>
          </li> -->
          <!-- <li title="Create a page" class="nav-item" *ngIf="
              verified && this.loginBtn == true && user.reviewProfileId == null
            ">
            <a class="nav-link" (click)="openCreatePageModal()"><i class="fi flaticon-user-add font-24"></i>
              <span class="nav-text font-16 fw-600">Create a page</span></a>
          </li> -->
          <!-- <li title="Your pages" class="nav-item" *ngIf="verified && this.loginBtn == true"
            [ngClass]="{ 'd-none': user.defaultProfileId == null }">
            <a class="nav-link" *ngIf="defaultProfile.profileName !== null"
              [routerLink]="['/profile/list-own-profiles']"><i class="fi flaticon-user-pencil font-24"></i>
              <span class="nav-text font-16 fw-600">Your pages</span></a>
          </li> -->
          <!-- <li class="nav-item">
            <a class="nav-link" [routerLink]="['/profile/list-own-profiles']"><i class="fi flaticon-notification font-24"></i></a>
          </li> -->

          <!-- profile notification start -->
          <li
            class="nav-item dropdown dropdown-img navigation-menu-notify notification-main"
            *ngIf="this.user !== null"
          >
            <!-- <a class="nav-link" [routerLink]="['/search']"><i class="fi flaticon-notification font-24"></i></a> -->
            <a
              class="nav-link dropdown-toggle icon-hover"
              role="button"
              id="dropdownMenuLink"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              (click)="getNotifications()"
            >
              <i class="fi flaticon-notification font-24">
                <span
                  class="badge"
                  *ngIf="notificationCount > 0 && notificationCount < 10"
                >
                  {{ notificationCount }}
                </span>
                <span class="badge1" *ngIf="notificationCount >= 10">
                  9 <span class="formore">+</span></span
                >
              </i>
              <span class="nav-text font-16 fw-600">Alerts</span>
            </a>

            <div
              class="dropdown-menu dropdown-menu-right mr-0 shadow notification-dropdown"
              aria-labelledby="dropdownMenuLink"
            >
              <div class="Notify-header d-none">
                <p class="text-center h6 my-2">Notifications</p>
                <button
                  type="button"
                  class="close btn btn-link btn-tbl-link-danger"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  data-target=".notification-main"
                >
                  <i class="fi flaticon-cancel"></i>
                </button>
              </div>
              <div
                class="notification-inner-main main-height"
                (scroll)="onScroll($event)"
              >
                <div class="notification-scroll">
                  <a
                    class="dropdown-item notification-changes px-2 pb-2 pt-1 cursor-pointer"
                    *ngFor="let notification of notificationList"
                    [ngClass]="{ unread: !notification.isRead }"
                  >
                    <div class="col-12 row m-0 px-0 notification-mobile-custom">
                      <div class="col-md-auto col-2 pl-0 pr-1 pt-2">
                        <a
                          class="nav-link btn dropdown-toggle btn-img-circle fix-avtar-3 mx-auto"
                          [routerLink]="[
                            '/profile/view-profile',
                            notification.byProfileTagName
                          ]"
                          (click)="$event.stopPropagation()"
                          id="dropdownMenuButton"
                          role="button"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          <img
                            *ngIf="
                              notification.byProfileImage == '' ||
                              notification.byProfileImage == null
                            "
                            src="../../../../assets/images/noprofile2.png"
                            alt="Profile Image"
                          />
                          <img
                            *ngIf="
                              notification.byProfileImage != '' &&
                              notification.byProfileImage != null
                            "
                            [src]="notification.byProfileImage"
                            onerror="this.src='../../../assets/images/noprofile2.png';"
                            alt="Profile Image"
                          />
                        </a>
                      </div>
                      <div
                        class="col-md-9 px-0 pl-2"
                        (click)="updateNotification(notification)"
                      >
                        <div class="lh-3-15 font-12">
                          <span class="h6 font-12 text-theme"
                            >{{ notification.byProfileName }}&nbsp;</span
                          >
                          <span class="font-gray font-12"
                            >({{ notification.byProfileTagName }})</span
                          >
                          <span
                            class="font-gray font-12 ml-1"
                            *ngIf="
                              notification.notification_type !==
                                'ANNOUNCEMENT' &&
                              notification.notification_type !==
                                'VIRTUAL_EVENT' &&
                              notification.notification_type !== 'NEW_POST' &&
                              notification.notification_type !== 'NEW_POLL'
                            "
                            >{{
                              notification.notification_type === 'MENTION'
                                ? 'mentioned you:'
                                : 'replied you:'
                            }}</span
                          >
                          <span
                            class="font-gray font-12"
                            *ngIf="
                              notification.notification_type === 'VIRTUAL_EVENT'
                            "
                          >
                            posted a virtual event:</span
                          >
                          <span
                            class="font-gray font-12"
                            *ngIf="
                              notification.notification_type === 'NEW_POST'
                            "
                          >
                            posted a conversation:</span
                          >
                          <span
                            class="font-gray font-12"
                            *ngIf="
                              notification.notification_type === 'NEW_POLL'
                            "
                          >
                            posted a poll:</span
                          >
                          <p
                            class="font-gray font-12"
                            *ngIf="
                              notification.notification_type === 'ANNOUNCEMENT'
                            "
                          >
                            posted an announcement:
                          </p>
                          <!-- (@{{notification.byProfileTagName}}) page: </span> -->
                          <!-- <span class="font-primary-color fw-600 font-12">@{{notification.onProfileTagName}} </span> -->
                          <p
                            class="text-theme font-12 notification-text"
                            *ngIf="
                              notification.notification_type !==
                                'ANNOUNCEMENT' &&
                              notification.notification_type !== 'VIRTUAL_EVENT'
                            "
                            [innerHTML]="
                              notification.content
                                | applinkifyHtml
                                  : { limit: true, limitChars: 20 }
                            "
                          ></p>
                          <!-- <span *ngIf="notification.notification_type !== 'ANNOUNCEMENT' && removeTags(notification.content).length > 20">
                            ...
                          </span> -->
                          <p
                            class="text-theme font-12 notification-text"
                            *ngIf="
                              notification.notification_type === 'ANNOUNCEMENT'
                            "
                            [innerHTML]="
                              notification.announcementHeading
                                | applinkifyHtml
                                  : { limit: true, limitChars: 20 }
                            "
                          ></p>

                          <p
                            class="text-theme font-12 notification-text"
                            *ngIf="
                              notification.notification_type === 'VIRTUAL_EVENT'
                            "
                            [innerHTML]="
                              notification.virtualEventTitle
                                | applinkifyHtml
                                  : { limit: true, limitChars: 20 }
                            "
                          ></p>

                          <!-- <span
                            *ngIf="notification.notification_type === 'ANNOUNCEMENT' && removeTags(notification.announcementHeading).length > 20">
                            ...

                          </span> -->
                        </div>
                        <div
                          *ngIf="
                            todayDate === notification.createdDate.substr(0, 10)
                          "
                          class="font-gray font-12"
                        >
                          {{ notification.daysAgo }}
                        </div>
                        <div
                          *ngIf="
                            todayDate != notification.createdDate.substr(0, 10)
                          "
                          class="font-gray font-12"
                        >
                          {{
                            notification.createdDate | date : 'MMM d, y' : 'UTC'
                          }}
                        </div>
                      </div>
                      <!-- <div class="col-1 d-flex align-items-center justify-content-end px-0">
                        <img src="../../../../assets/images/cross_img.svg" class="cursor-pointer" (click)="deleteNotification(notification.id)">
                      </div> -->
                      <img
                        src="../../../../assets/images/cross_img.svg"
                        class="cursor-pointer ml-auto mr-2"
                        (click)="deleteNotification(notification.id, $event)"
                      />
                    </div>
                  </a>
                  <a
                    class="dropdown-item notification-changes px-2 py-3 last-notification mb-0 notification-message"
                    *ngIf="notificationList.length == 0"
                  >
                    <div class="col-12 row m-0 px-0 notification-mobile-custom">
                      <!-- <div class="col-md-auto col-2 pl-0 pr-1 pt-sm-1"> -->
                      <!-- <a [routerLink]="['/profile/view-profile/', review.byProfileTagName]" (click)="$event.stopPropagation()" class="btn btn-img-circle fix-avtar-3 mx-auto">
                      <img *ngIf="!review.byProfileImage" src="../../../assets/images/noprofile2.png" alt="Profile Image" />
                      <img *ngIf="!!review.byProfileImage" [src]="review.byProfileImage" alt="Profile Image" />
                    </a> -->
                      <!-- <a class="nav-link btn dropdown-toggle btn-img-circle fix-avtar-3 mx-auto fixed-link"
                          id="dropdownMenuButton" role="button" data-toggle="dropdown" aria-haspopup="true"
                          aria-expanded="false">
                          <img src="../../../../assets/images/new-logo-text.png" alt="Profile Image" />
                        </a> -->
                      <!-- </div> -->
                      <div
                        class="col-12 px-0 d-flex align-items-center justify-content-center"
                      >
                        <div>
                          <p class="font-16 text-theme fw-600">
                            No Notification
                          </p>
                          <!-- <p class="h6 font-14 text-theme">Welcome to CitizeX</p>
                          <p class="font-gray font-12">
                            Hi {{ user.firstName }}! Welcome to CitizeX. Complete
                            your verification with easy steps.
                          </p> -->
                          <!-- <span *ngIf="notification.content.length > 225">
                        ...
                      </span> -->
                        </div>
                        <!-- <img src="../../../../assets/images/cross_img.svg" class="cursor-pointer"> -->
                        <!-- <div class="font-gray font-12">{{notification.daysAgo}}</div> -->
                      </div>
                    </div>
                  </a>
                </div>
                <div
                  class="dropdown-item btn-link btn-link-theme text-center p-1 cursor-pointer"
                  (click)="deleteNotification()"
                  *ngIf="notificationList.length > 0"
                >
                  Clear All
                </div>
                <!-- <a class="dropdown-item" href="#">Another action</a>
            <a class="dropdown-item" href="#">Something else here</a> -->
                <!-- <div class="dropdown-item loader-custom" [style.display]="loading">
              <div [style.display]="loading" id="imagloader" class="view-profileLoader1"></div>
            </div> -->
              </div>
            </div>
            <!-- notification end -->
          </li>
          <!-- profile notification end -->

          <li
            *ngIf="this.loginBtn == true"
            class="nav-item dropdown dropdown-img navigation-menu"
          >
            <a
              class="nav-link btn dropdown-toggle btn-img-circle fix-avtar-2-5 mx-auto"
              href="#"
              id="dropdownmenu"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <img
                *ngIf="
                  defaultProfile.profileImage == '' ||
                  defaultProfile.profileImage == null
                "
                src="../../../../assets/images/noprofile2.png"
                alt="Profile Image"
              />
              <img
                *ngIf="
                  defaultProfile.profileImage != '' &&
                  defaultProfile.profileImage != null
                "
                [src]="defaultProfile.profileImage"
                onerror="this.src='../../../assets/images/noprofile2.png';"
                alt="Profile Image"
              />
            </a>
            <div
              class="dropdown-menu dropdown-menu-right mr-0 shadow dropdown-scroll"
              aria-labelledby="dropdownMenuButton"
            >
              <button
                type="button"
                class="close btn btn-link btn-tbl-link-danger"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                data-target=".navigation-menu"
              >
                <i class="fi flaticon-cancel"></i>
              </button>
              <div class="text-center px-3 py-2">
                <button
                  *ngIf="defaultProfile.profileName != null"
                  [routerLink]="[
                    '/profile/view-profile/',
                    defaultProfile.tagName
                  ]"
                  class="btn btn-img-circle fix-avtar-4 my-1 mx-auto"
                  (click)="closeNavbarCollepse()"
                >
                  <img
                    *ngIf="
                      defaultProfile.profileImage == '' ||
                      defaultProfile.profileImage == null
                    "
                    src="../../../../assets/images/noprofile2.png"
                    alt="Profile Image"
                  />
                  <img
                    *ngIf="
                      defaultProfile.profileImage != '' &&
                      defaultProfile.profileImage != null
                    "
                    [src]="defaultProfile.profileImage + '?' + timestamp"
                    onerror="this.src='../../../assets/images/noprofile2.png';"
                    alt="Profile Image"
                  />
                </button>
                <button
                  *ngIf="defaultProfile.profileName == null"
                  class="btn btn-img-circle fix-avtar-4 my-1 mx-auto"
                  (click)="closeNavbarCollepse()"
                >
                  <img
                    *ngIf="
                      defaultProfile.profileImage == '' ||
                      defaultProfile.profileImage == null
                    "
                    src="../../../../assets/images/noprofile2.png"
                    alt="Profile Image"
                  />
                  <img
                    *ngIf="
                      defaultProfile.profileImage != '' &&
                      defaultProfile.profileImage != null
                    "
                    [src]="defaultProfile.profileImage"
                    onerror="this.src='../../../assets/images/noprofile2.png';"
                    alt="Profile Image"
                  />
                </button>
                <h4 class="p-1" *ngIf="!verified">
                  {{ nonVerifiedUser.firstName }} {{ nonVerifiedUser.lastName }}
                </h4>
                <h6 class="p-1" *ngIf="!verified">
                  &#64;{{ nonVerifiedUser.userName }}
                </h6>
                <h4
                  class="p-1"
                  *ngIf="verified && defaultProfile.profileName == null"
                >
                  {{ nonVerifiedUser.firstName }} {{ nonVerifiedUser.lastName }}
                </h4>
                <h6
                  class="p-1"
                  *ngIf="verified && defaultProfile.profileName == null"
                >
                  &#64;{{ nonVerifiedUser.userName }}
                </h6>
                <h4
                  class="p-1"
                  *ngIf="verified && defaultProfile.publicName !== null"
                >
                  {{ defaultProfile.publicName }}
                </h4>
                <h6
                  class="p-1"
                  *ngIf="verified && defaultProfile.profileName !== null"
                >
                  &#64;{{ defaultProfile.tagName }}
                </h6>
                <a
                  *ngIf="defaultProfile.id"
                  class="btn btn-underline font-16"
                  [routerLink]="['/profile/edit-profile/', defaultProfile.id]"
                  (click)="closeNavbarCollepse()"
                  ><i class="fi flaticon-edit mr-0" id="editOption"></i> Edit</a
                >
              </div>
              <div class="dropdown-divider"></div>
              <!-- <a class="btn dropdown-item pointer" [routerLink]="['/profile/edit-profile/', defaultProfile.id]"><i class="fi flaticon-logout"></i> Edit</a> -->
              <a
                id="menu-blocked-profiles"
                class="btn dropdown-item pointer"
                [routerLink]="['/profile/block-profile/']"
                (click)="closeNavbarCollepse()"
                ><i class="fi flaticon-user-remove fw-600"></i> Blocked
                Profiles</a
              >
              <div class="dropdown-divider" *ngIf="verified == false"></div>
              <div class="extra" *ngIf="verified == false"></div>
              <!-- <a class="btn dropdown-item pointer" (click)="openCreatePageModal()"
                *ngIf="verified && this.loginBtn == true && user.reviewProfileId == null"><i class="fi flaticon-user-add fw-600"></i>
                <span class="ml-sm-1">Create a page</span></a>
              <div class="dropdown-divider"></div>
              <div class="extra" (click)="$event.stopPropagation()"></div> -->
              <a
                id="menu-verification-status"
                class="btn dropdown-item pointer dropdown-icon"
                [routerLink]="['/signup']"
                *ngIf="verified == false"
                (click)="closeNavbarCollepse()"
                ><i
                  *ngIf="verified == false"
                  class="fi flaticon-shield-failed font-danger fw-600"
                ></i>
                <!--   <i *ngIf="verified == true" class="fi flaticon-shield-success font-success fw-600"></i>-->
                <span class="ml-sm-1">Verification status</span></a
              >
              <!-- <div class="dropdown-divider"></div>
              <div class="extra" (click)="$event.stopPropagation()"></div>
              <a class="btn dropdown-item pointer" *ngIf="defaultProfile.profileName !== null && verified && this.loginBtn == true"
                [ngClass]="{ 'd-none': user.defaultProfileId == null }" [routerLink]="['/profile/list-own-profiles']"><i
                  class="fi flaticon-user-pencil fw-600"></i>
                <span class="ml-sm-1">Your pages</span></a> -->
              <div class="dropdown-divider"></div>
              <a
                class="btn dropdown-item pointer"
                (click)="goToReportAbuse($event)"
                ><i class="fi flaticon-warning fw-600"></i> Report an Abuse</a
              >
              <div class="dropdown-divider"></div>
              <div
                id="menu-feedback"
                class="have-feedback d-flex align-items-center dropdown-icon"
                (click)="openFeedbackModal()"
              >
                <img
                  src="../../../../assets/images/feedback-img.svg"
                  alt="have feedback"
                  class="profile-icons"
                />
                <a class="btn dropdown-item pointer ml-sm-1"> Have feedback?</a>
              </div>
              <div class="dropdown-divider"></div>
              <div
                class="extra"
                (click)="$event.stopPropagation()"
                *ngIf="verified"
              ></div>
              <a
                id="menu-update-address"
                class="btn dropdown-item pointer dropdown-icon"
                *ngIf="verified"
                (click)="Updateaddress()"
                ><i class="fi flaticon-edit fw-600"></i> Update my address</a
              >
              <div class="dropdown-divider" *ngIf="verified"></div>
              <div
                class="extra"
                (click)="$event.stopPropagation()"
                *ngIf="verified"
              ></div>
              <!-- <a class="btn dropdown-item pointer dropdown-icon"  (click)="phonoModal()"><i
              class="fi flaticon-text-message-1 fw-600"></i>
            Update Phone no </a> -->
              <div
                id="menu-update-phone"
                class="have-feedback d-flex align-items-center dropdown-icon"
                (click)="phonoModal()"
                *ngIf="verified"
              >
                <img
                  src="../../../../assets/images/update-phone-no.svg"
                  class="profile-icons edit-img"
                />
                <a class="btn dropdown-item pointer ml-sm-1 p-0"
                  >Update Phone no</a
                >
              </div>
              <div
                class="extra"
                (click)="$event.stopPropagation()"
                *ngIf="verified"
              ></div>
              <div class="dropdown-divider" *ngIf="verified"></div>
              <!-- <a class="btn dropdown-item pointer dropdown-icon" (click)="updateemail()"><i
              class="fi flaticon-edit fw-600"></i>
            Update my email</a> -->
              <div
                id="menu-update-email"
                class="have-feedback d-flex align-items-center dropdown-icon"
                (click)="updateemail()"
                *ngIf="verified"
              >
                <img
                  src="../../../../assets/images/update-email.svg"
                  class="profile-icons edit-img"
                />
                <a class="btn dropdown-item pointer ml-sm-1 p-0"
                  >Update Email</a
                >
              </div>
              <div
                class="extra"
                (click)="$event.stopPropagation()"
                *ngIf="verified && user.defaultProfileId != null"
              ></div>
              <div
                class="dropdown-divider"
                *ngIf="verified && user.defaultProfileId != null"
              ></div>
              <div
                id="menu-name-setting"
                class="have-feedback d-flex align-items-center dropdown-icon"
                (click)="nameSettingModal()"
                *ngIf="verified && user.defaultProfileId != null"
              >
                <img
                  src="../../../../assets/images/name-setting-img.svg"
                  class="profile-icons edit-img"
                />
                <a class="btn dropdown-item pointer ml-sm-1 p-0"
                  >Name Setting</a
                >
              </div>
              <div
                class="extra"
                (click)="$event.stopPropagation()"
                *ngIf="verified"
              ></div>
              <div class="dropdown-divider" *ngIf="verified"></div>
              <div
                class="have-feedback email-notification-row d-flex align-items-center dropdown-icon"
                (click)="$event.stopPropagation()"
              >
                <i
                  class="fi flaticon-notification profile-icons edit-img fw-600"
                ></i>

                <a
                  class="btn dropdown-item pointer email-notification-label ml-sm-1 p-0"
                  style="white-space: nowrap"
                >
                  Email Notifications
                </a>

                <label class="switch mb-0 ml-auto mr-1" style="flex-shrink: 0">
                  <input
                    type="checkbox"
                    [(ngModel)]="emailNotificationsEnabled"
                    [ngModelOptions]="{ standalone: true }"
                    (ngModelChange)="updateEmailNotifications($event)"
                    (click)="$event.stopPropagation()"
                  />
                  <span class="slider round"></span>
                </label>
              </div>
              <div
                class="extra"
                (click)="$event.stopPropagation()"
                *ngIf="verified"
              ></div>
              <div class="dropdown-divider"></div>
              <!-- <div class="dropdown-divider"></div> -->
              <!-- <div class="have-feedback d-flex align-items-center dropdown-icon" *ngIf="verified" data-toggle="modal" data-target="#virtualEventModal">
                <img src="../../../../assets/images/virtul-event-icon.svg" class="profile-icons edit-img">
                <a class="btn dropdown-item pointer ml-sm-1 p-0">Virtual Event Settings</a>
              </div>
              <div class="dropdown-divider"></div>
              <div class="dropdown-divider" *ngIf="verified"></div> -->
              <a
                id="menu-logout"
                class="btn dropdown-item pointer"
                (click)="logOut()"
                ><i class="fi flaticon-logout fw-600"></i> Logout</a
              >
              <div class="extra"></div>

              <div class="dropdown-divider"></div>
              <!-- <a class="btn dropdown-item pointer" [routerLink]="['/profile/edit-profile/', defaultProfile.id]"><i class="fi flaticon-logout"></i> Edit</a> -->
              <a
                id="menu-delete-account"
                class="btn dropdown-item pointer dropdown-icon"
                [routerLink]="['/deleteAccount']"
                (click)="closeNavbarCollepse()"
                ><i class="fi flaticon-delete fw-600"></i> Delete Account</a
              >
              <div class="extra"></div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </nav>
  <a
    class="extra-header"
    data-toggle="collapse"
    data-target="#navbarNavDropdown"
    aria-controls="navbarNavDropdown"
    aria-expanded="false"
    aria-label="Toggle navigation"
    [ngClass]="{ 'collapsed-header': isMenuOpen }"
  ></a>
</header>

<header class="profile-header" *ngIf="headerStyle == 'privacyAndPolicy'">
  <nav class="navbar navbar-expand-md py-0 minh-100">
    <div class="col-auto">
      <a
        [routerLink]="['/homepage']"
        class="navbar-brand btn btn-img-no-effect h-40px d-block border-0"
      >
        <img
          src="../../../../assets/images/logo-text.png"
          class=""
          alt="Logo Image"
        />
      </a>
    </div>
  </nav>
</header>

<!-- Restriction Modal -->
<div
  class="modal fade"
  id="restrictModal"
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
>
  <div
    class="modal-dialog modal-dialog-custom modal-dialog-centered modal-sm"
    role="document"
  >
    <div class="modal-content">
      <div class="modal-body">
        <h1 class="text-center theme-color">
          <i class="fi flaticon-information font-40"></i>
        </h1>
        <h6 class="text-center bold my-3 theme-color">Sorry !</h6>
        <p class="text-center theme-color">
          Please complete all the verification steps first.
        </p>
        <div class="col-12 text-center">
          <button
            [routerLink]="['/signup']"
            class="btn btn-outline-black mt-4 mb-2 mx-2 py-1 font-12"
            data-dismiss="modal"
          >
            Get Verified
          </button>
        </div>
      </div>
      <!-- .modal-body -->
    </div>
    <!-- .modal-content -->
  </div>
  <!-- .modal-dialog -->
</div>
<!-- #restrictModal -->
<!-- Restriction Modal Ends -->

<!-- Restriction Modal -->
<div
  class="modal fade"
  id="restrictProfileModal"
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
>
  <div
    class="modal-dialog modal-dialog-custom modal-dialog-centered modal-sm"
    role="document"
  >
    <div class="modal-content">
      <div class="modal-body">
        <h1 class="text-center theme-color">
          <i class="fi flaticon-information font-40"></i>
        </h1>
        <h6 class="text-center bold my-3 theme-color">Sorry !</h6>
        <p class="text-center theme-color">
          You must have your own profile on CitizeX to post a review.
        </p>
        <div class="col-12 text-center">
          <button
            [routerLink]="['/profile/search-profile']"
            class="btn btn-outline-black mt-4 mb-2 mx-2 py-1 font-12"
            data-dismiss="modal"
          >
            Create your page
          </button>
        </div>
      </div>
      <!-- .modal-body -->
    </div>
    <!-- .modal-content -->
  </div>
  <!-- .modal-dialog -->
</div>
<!-- #restrictModal -->
<!-- Restriction Modal Ends -->

<div
  class="modal fade"
  id="createPageModal"
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
>
  <div
    class="modal-dialog modal-dialog-custom modal-dialog-centered modal-md"
    role="document"
  >
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title mt-2 mb-2">Create a Page</h5>
        <button
          type="button"
          class="close mt-2 font-32"
          aria-label="Close"
          data-dismiss="modal"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p class="text-justify theme-color mb-2">
          As a verified user, you must create a page with your information
          before you can start posting reviews. Please make sure that your first
          name, last name and date of birth matches your government issued ID
          used for verification.
        </p>
        <p class="text-justify theme-color mb-2">
          Once you create your own page, you will be able to create pages for
          other individuals. However, any page created for any individual will
          remain "unclaimed" until claimed by the individual.
        </p>
        <p class="text-justify theme-color mb-2">
          *Please refrain from making fake or duplicate pages else your account
          will be flagged!
        </p>
        <div class="col-12 text-center">
          <button
            class="btn btn-black mt-4 mb-2 mx-2 py-2 px-sm-2 px-3 font-14"
            (click)="redirectToCreateProfilePage()"
          >
            Continue
          </button>
        </div>
      </div>
      <!-- .modal-body -->
    </div>
    <!-- .modal-content -->
  </div>
  <!-- .modal-dialog -->
</div>

<div
  class="modal fade"
  id="deleteAccountModal"
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
>
  <div
    class="modal-dialog modal-dialog-custom modal-dialog-centered modal-md"
    role="document"
  >
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title mt-2 mb-2">Delete Account</h3>
        <button
          type="button"
          class="close mt-2 font-32"
          aria-label="Close"
          data-dismiss="modal"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p class="text-justify theme-color mb-2 delete_account">
          Are you sure you want to delete this account?
        </p>
        <div class="col-12 text-center">
          <button
            type="reset"
            class="btn btn-outline-black mt-4 mb-2 mx-2 font-16 mw-auto"
            data-dismiss="modal"
          >
            No
          </button>
          <button
            class="btn btn-black mt-4 mb-2 mx-2 font-16 mw-auto"
            (click)="deleteAccount()"
          >
            Yes
          </button>
        </div>
      </div>
      <!-- .modal-body -->
    </div>
    <!-- .modal-content -->
  </div>
  <!-- .modal-dialog -->
</div>
<!------------------------About-Us-Modal------------->
<div
  class="modal fade"
  id="aboutUsModal"
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
  data-backdrop="static"
  data-keyboard="false"
>
  <div
    class="modal-dialog modal-dialog-custom modal-dialog-centered modal-dialog-scrollable"
    role="document"
  >
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title mt-2 mb-2">About Us</h3>
        <button
          type="button"
          class="close mt-2 font-32"
          aria-label="Close"
          data-dismiss="modal"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p class="text-justify theme-color mb-2">
          CitizeX is a civic engagement platform built to bring clarity, trust,
          and real human connection back to public discourse. It connects
          voters, elected officials, candidates, and organizations with the goal
          of fostering authentic dialogue through modern technology.
        </p>
        <p class="text-justify theme-color mb-2">
          At a time when political discourse is often shaped by anonymity,
          misinformation, and algorithm-driven noise, CitizeX creates a more
          credible alternative. Every participant contributing to CitizeX is
          verified, ensuring that conversations happen between real people. No
          bots, fake accounts, or impersonators are allowed to comment.
        </p>
        <p class="text-justify theme-color mb-2">
          The platform enables users to discover and engage directly with
          leaders at the national, state, and local levels through virtual town
          halls, community discussions, and polling. Rather than passively
          consuming content, users can ask questions, share perspectives, and
          participate in ongoing civic dialogue in a space built for
          accountability and transparency.
        </p>
        <p class="text-justify theme-color mb-2">
          Powered by key partners, CitizeX combines advanced technology with
          trusted verification to create a more reliable civic experience.
          Coresee, a video conferencing platform, enables elected officials,
          candidates, and organizations to host live public conversations with
          tools designed to better present ideas, structure dialogue, and gather
          meaningful feedback from participants. CitizeX also uses an API
          provided by
          <b
            ><u
              ><a
                href="https://www.cicerodata.com/company/"
                target="_blank"
                style="color: blue"
                >Cicero</a
              ></u
            ></b
          >
          to generate current elected official offices and bios.
        </p>
        <p class="text-justify theme-color mb-2">
          CitizeX was built on a simple idea: public dialogue works better when
          people know they are hearing from real people. By combining verified
          identity with tools for direct engagement, CitizeX offers a new model
          for digital democracy, and one that is more trustworthy, more
          informed, and more human.
        </p>
      </div>
      <!-- .modal-body -->
    </div>
    <!-- .modal-content -->
  </div>
  <!-- .modal-dialog -->
</div>

<!-- Restriction Modal -->
<div
  class="modal fade"
  id="restrictUnclaimedProfileModal"
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
>
  <div
    class="modal-dialog modal-dialog-custom modal-dialog-centered modal-sm"
    role="document"
  >
    <div class="modal-content">
      <div class="modal-body">
        <h1 class="text-center theme-color">
          <i class="fi flaticon-information font-40"></i>
        </h1>
        <h6 class="text-center bold my-3 theme-color">Sorry !</h6>
        <p class="text-center theme-color">
          To access this feature, your claim request needs to be approved. Your
          request is currently under review, and you’ll be notified within 24–48
          hours.
        </p>
        <div class="col-12 text-center">
          <button
            type="button"
            class="btn btn-outline-black mt-4 mb-2 mx-2 py-1 font-12"
            data-dismiss="modal"
          >
            Ok
          </button>
        </div>
      </div>
      <!-- .modal-body -->
    </div>
    <!-- .modal-content -->
  </div>
  <!-- .modal-dialog -->
</div>
<!-- #restrictModal -->

<!-- have feedback modal  -->
<div
  class="modal fade havefeedbackmodal"
  tabindex="-1"
  role="dialog"
  id="haveFeedback"
  data-backdrop="static"
  data-keyboard="false"
>
  <div
    class="modal-dialog modal-dialog-custom modal-dialog-centered"
    role="document"
  >
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-20 fw-600">Have Feedback?</h5>
        <button
          type="button"
          class="close"
          aria-label="Close"
          data-dismiss="modal"
          (click)="resetFormData(feedbackForm)"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form
          #feedbackForm="ngForm"
          (ngSubmit)="sendBugReportOrFeedback(feedbackForm)"
          novalidate
        >
          <div class="form-group d-flex aling-items-center radio-btn-group">
            <label class="d-flex align-items-center font-18 fw-600 mb-0"
              >Report a bug
              <input
                type="radio"
                name="feedback"
                value="report a bug"
                [(ngModel)]="reportBugFeedbackDTO.type"
                class="ml-3"
                required
                #type="ngModel"
            /></label>
            <label class="d-flex align-items-center font-18 fw-600 mb-0"
              >Feedback
              <input
                type="radio"
                name="feedback"
                value="feedback"
                [(ngModel)]="reportBugFeedbackDTO.type"
                class="ml-3"
                required
                #type="ngModel"
              />
            </label>
          </div>
          <div
            *ngIf="feedbackForm.submitted && type.invalid"
            class="text-danger mb-2 text-center"
          >
            Please select a feedback type.
          </div>
          <div class="form-group">
            <label for="description" class="font-16 fw-600">Description</label>
            <textarea
              id="description"
              class="form-control"
              rows="5"
              [(ngModel)]="reportBugFeedbackDTO.description"
              name="description"
              required
              maxlength="1000"
              #description="ngModel"
              NoLeadingWhitespace
            ></textarea>
            <div
              *ngIf="feedbackForm.submitted && description.invalid"
              class="text-danger"
            >
              <span *ngIf="description.errors?.['required']"
                >Description is required.</span
              >
              <span *ngIf="description.errors?.['maxlength']"
                >You've reached the maximum limit of 1000 characters.</span
              >
            </div>
          </div>
          <div class="d-flex justify-content-end mr-4">
            <button
              type="button"
              class="btn btn-outline-black mt-4 pt-2 mb-3 mx-2 font-16 fw-600"
              data-dismiss="modal"
              (click)="resetFormData(feedbackForm)"
            >
              Cancel
            </button>
            <button
              type="submit"
              class="btn btn-black mt-4 pt-2 mb-3 mx-2 font-16 fw-600"
            >
              Report
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<!-- have feedback modal  -->
<!----------------Update-My-Address-Modal-------------->
<div
  class="modal fade"
  id="UpdateAddressModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalCenterTitle"
  aria-hidden="true"
>
  <div
    class="modal-dialog modal-dialog-custom modal-dialog-centered"
    role="document"
  >
    <div class="modal-content">
      <!-- <div class="modal-header">
        <h3 class="modal-title font-20 fw-600" id="exampleModalLongTitle">Update my address</h3>
        <button
        type="button"
        class="close mt-2 font-32"
        aria-label="Close"
        data-dismiss="modal">
        <span aria-hidden="true">&times;</span>
      </button>
      </div> -->
      <div class="modal-body">
        <p class="font-16 fw-600">
          Please complete the verification using an ID that has your updated
          address.
        </p>
        <div class="col-12 text-center mt-4 mb-2 mx-2">
          <button
            type="button"
            class="btn btn-outline-black font-16 fw-400"
            (click)="verifymodal()"
          >
            ok
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<!---------------------verify-Modal----------------->
<div
  id="diditModal"
  class="modal fade"
  tabindex="-1"
  role="dialog"
  aria-labelledby="phoneNumberModalTitle"
  aria-hidden="true"
>
  <div
    class="modal-dialog modal-dialog-centered modal-dialog-custom modal-theme"
    role="document"
  >
    <div class="modal-content">
      <div class="modal-body p-5">
        <button
          aria-label="Close"
          class="close close-modal"
          data-dismiss="modal"
          type="button"
        >
          <span class="fi flaticon-cancel"></span>
        </button>
        <h3 class="text-center">Didit Verification</h3>
        <p class="mb-0 mt-3 text-center text-muted">
          Preparing your secure identity verification session...
        </p>
      </div>
    </div>
  </div>
</div>
<div
  class="modal fade"
  id="diditErrorModal"
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
>
  <div
    class="modal-dialog modal-dialog-centered conversation-Modal"
    role="document"
  >
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title fw-700 font-18" id="exampleModalLongTitle">
          Error
        </h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="mt-2" *ngIf="diditStatus == 'rejection'">
          <span style="font-size: 14px" class="verified">
            Your request has been rejected due to a mismatch in ID.
            <!-- To update your user information, please click here and try again.
            <a style="color: #161616;" data-dismiss="modal" [routerLink]="['/edit-user']"><u class="fw-700"
                style="text-decoration: none;">Click
                here</u></a>
            and retry. -->
          </span>
          <p class="font-13 fw-600 mt-2">
            Possible reasons for the rejection include:
          </p>
          <div class="col mt-1 pl-4 mb-2">
            <ul class="ul-style">
              <li class="list-symbol">
                Missing middle name in the 'first and middle name' field during
                sign-up.
              </li>
              <li class="list-symbol">
                The name entered at sign-up does not match the name on your ID.
              </li>
              <li class="list-symbol">An extra space after your last name.</li>
            </ul>
          </div>
        </div>
        <div *ngIf="diditStatus == 'declined'">
          <span style="font-size: 15px" class="verified">
            Your request has been declined , please retry.</span
          >
        </div>
        <div class="col-12 text-center mt-3">
          <button
            type="button"
            class="btn btn-black font-14"
            data-dismiss="modal"
          >
            Ok
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Update address Model  -->
<div
  class="modal fade"
  id="UpdateAddressesModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalCenterTitle"
  aria-hidden="true"
  data-backdrop="static"
>
  <div
    class="modal-dialog modal-dialog-custom modal-dialog-centered"
    role="document"
  >
    <div class="modal-content">
      <div class="modal-body">
        <p class="font-16 fw-600">Address Updated</p>
        <div class="col-12 text-center mt-4 mb-2 mx-2">
          <button
            type="button"
            class="btn btn-outline-black font-16 fw-400"
            data-dismiss="modal"
            (click)="closePopup()"
          >
            Ok
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<!------------------------Update-Phone-No-Modal------------------->
<div
  id="phoneNumberModalHeader"
  class="modal fade"
  tabindex="-1"
  role="dialog"
  aria-labelledby="phoneNumberModalTitle"
  aria-hidden="true"
  data-backdrop="static"
  data-keyboard="false"
>
  <div
    class="modal-dialog modal-dialog-centered modal-dialog-custom modal-theme"
    role="document"
  >
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-20 fw-600" id="exampleModalLongTitle">
          Update Phone No
        </h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          (click)="resetFormData(f)"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div
          *ngIf="otpResendCooldownMsg"
          class="col-md-12 my-2 alert alert-danger"
        >
          {{ otpResendCooldownMsg }}
          <button
            (click)="otpResendCooldownMsg = ''"
            type="button"
            class="close"
            data-dismiss="alert"
            aria-label="Close"
          >
            <span class="text-danger">&times;</span>
          </button>
        </div>
        <div *ngIf="phoneChangeError" class="alert alert-danger col-md-12 my-2">
          {{ phoneChangeError }}
          <button
            (click)="phoneChangeError = ''"
            type="button"
            class="close"
            data-dismiss="alert"
            aria-label="Close"
          >
            <span class="text-danger">&times;</span>
          </button>
        </div>
        <div
          *ngIf="phoneNoErrMsg != ''"
          class="col-md-12 my-2 alert alert-danger"
        >
          {{ phoneNoErrMsg }}
          <button
            type="button"
            (click)="phoneNoErrMsg = ''"
            class="close"
            data-dismiss="alert"
            aria-label="Close"
          >
            <span>&times;</span>
          </button>
        </div>
        <form
          class="row square-form needs-validation px-4"
          (ngSubmit)="sendOTP(f.invalid)"
          #f="ngForm"
          novalidate
          autocomplete="off"
        >
          <div class="row m-0 mobile-input-with-flag">
            <label
              for="countryCode"
              class="col-12 m-0 pl-0 pb-2 control-label fw-600"
            >
              Enter your mobile number</label
            >
            <div
              class="col-auto pl-0 form-group countryCode-flag mt-2 d-flex align-items-center"
            >
              <img
                *ngIf="selectedCountry?.flagUrl"
                [src]="selectedCountry.flagUrl"
                class="country-flag-img"
                alt="flag"
              />
              <img
                *ngIf="!selectedCountry?.flagUrl"
                src="assets/images/flag_placeholder.png"
                class="flag flag-us"
                alt="flag"
              />
            </div>
            <div class="col pl-0 form-group mt-2">
              <div class="country-code-dropdown">
                <button
                  class="btn country-code-btn form-control"
                  type="button"
                  (click)="toggleCountryDropdown($event)"
                >
                  {{ selectedCountry?.callingCode || '+1' }}
                  <span class="dropdown-caret">&#9660;</span>
                </button>
                <div class="country-dropdown-menu" *ngIf="countryDropdownOpen">
                  <div class="country-search-wrap px-2 pb-1">
                    <input
                      #countrySearchInput
                      type="text"
                      class="form-control country-search-input"
                      placeholder="Search country..."
                      [(ngModel)]="countrySearchTerm"
                      (input)="filterCountries()"
                      name="countrySearchHeader"
                      autocomplete="off"
                      (click)="$event.stopPropagation()"
                    />
                  </div>
                  <div class="country-list">
                    <a
                      class="dropdown-item country-item"
                      *ngFor="let country of filteredCountries"
                      (click)="selectCountry(country)"
                    >
                      <img
                        [src]="country.flagUrl"
                        class="country-flag-img"
                        alt="flag"
                      />
                      <span class="country-name">{{ country.name }}</span>
                      <span class="country-code ml-auto">{{
                        country.callingCode
                      }}</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 col-sm-8 col-md-7 pl-0 form-group mt-2">
              <input
                type="text"
                class="form-control min-width-20ch"
                id="phoneNumber"
                name="phoneNumber"
                [(ngModel)]="phoneNumber"
                inputmode="tel"
                required
                mask="(000) 000-0000"
                inputmode="tel"
                #phoneCtrl="ngModel"
                minlength="10"
              />
              <div
                *ngIf="f.submitted && (phoneCtrl.touched || phoneCtrl.invalid)"
                class="text-danger"
              >
                <span *ngIf="phoneCtrl.errors?.['required']"
                  >Phone number is required.</span
                >
                <span *ngIf="phoneCtrl.errors?.['pattern']"
                  >Phone number must be exactly 10 digits.</span
                >
              </div>
            </div>
            <div class="col-md-12 pt-4 text-center">
              <input
                type="submit"
                class="btn btn-black"
                value="Send Code"
                [disabled]="otpResendBlocked || otpSendInFlight"
              />
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<!----------------------Verification-Modal------------------>
<div
  id="phoneOtpModal"
  class="modal fade"
  tabindex="-1"
  role="dialog"
  aria-labelledby="phoneNumberModalTitle"
  aria-hidden="true"
  data-backdrop="static"
  data-keyboard="false"
>
  <div
    class="modal-dialog modal-dialog-centered modal-dialog-custom modal-theme"
    role="document"
  >
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-20 fw-600" id="exampleModalLongTitle">
          Update Phone No
        </h5>
        <button
          type="button"
          class="close"
          (click)="resetFormData(otpModal)"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div>
          <form
            class="row px-4 square-form needs-validation"
            (ngSubmit)="otpVerify(otpModal)"
            #otpModal="ngForm"
            novalidate
            autocomplete="off"
          >
            <div
              *ngIf="otpResent && !otpResendBlocked"
              class="col-md-12 my-2 alert alert-info"
            >
              OTP sent again.
              <button
                (click)="otpResent = false"
                type="button"
                class="close"
                data-dismiss="alert"
                aria-label="Close"
              >
                <span>&times;</span>
              </button>
            </div>
            <div
              *ngIf="otpResendCooldownMsg"
              class="col-md-12 my-2 alert alert-danger"
            >
              {{ otpResendCooldownMsg }}
              <button
                (click)="otpResendCooldownMsg = ''"
                type="button"
                class="close"
                data-dismiss="alert"
                aria-label="Close"
              >
                <span class="text-danger">&times;</span>
              </button>
            </div>
            <div
              *ngIf="phoneChangeError"
              class="alert alert-danger col-md-12 my-2"
            >
              {{ phoneChangeError }}
              <button
                (click)="phoneChangeError = ''"
                type="button"
                class="close"
                data-dismiss="alert"
                aria-label="Close"
              >
                <span class="text-danger">&times;</span>
              </button>
            </div>
            <div class="col-12">
              <label
                for="input"
                class="col-12 m-0 text-center control-label font-16 fw-600"
                >Enter Code</label
              >
              <div class="col-10 activation-grid item-4 form-group mx-auto">
                <div
                  [ngClass]="{
                    'is-invalid':
                      invalidOTP == true ||
                      (otpModal.submitted &&
                        (otpModal.untouched || otpModal.invalid))
                  }"
                  *ngFor="
                    let item of otpCodeArr;
                    let index = index;
                    trackBy: trackByIndex
                  "
                >
                  <div class="input-field my-0">
                    <input
                      type="text"
                      [attr.tabindex]="index + 1"
                      [attr.id]="'otpCode' + index"
                      [name]="'otpCode' + index"
                      class="form-control text-center activation-field h-2"
                      maxlength="1"
                      [(ngModel)]="otpCodeArr[index]"
                      required
                      inputmode="tel"
                      (paste)="onPestCode($event, 'otpCode', 4)"
                      (input)="keytabOTP(index, $event, 'input')"
                      (keyup)="keytabOTP(index, $event, 'keyup')"
                    />
                  </div>
                </div>
              </div>
              <div class="text-center mt-2 invalid-feedback d-block">
                <!-- invalid-feedback -->
                <span *ngIf="otpModal.submitted && otpModal.invalid">
                  Please enter verification code sent to your registered phone.
                </span>
                <span *ngIf="invalidOTP"> Invalid OTP. </span>
              </div>
            </div>
            <!-- .col -->

            <div class="col-md-12 pt-4 text-center">
              <button type="submit" class="btn btn-black mt-2" tabindex="5">
                Continue
              </button>
              <p class="font-14 font-gray mt-3">
                Didn't get verification code?
                <button
                  type="button"
                  (click)="resendOTP(otpModal)"
                  class="btn btn-link btn-link-theme font-14 p-0"
                  tabindex="6"
                  [disabled]="otpResendBlocked || otpSendInFlight"
                >
                  &nbsp;Resend now
                </button>
              </p>
            </div>
            <!-- .col -->
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
<!--------------Update-My-Email-Modal--------------->
<div
  class="modal fade update-email-modal"
  id="emailModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalCenterTitle"
  aria-hidden="true"
  data-backdrop="static"
  data-keyboard="false"
>
  <div
    class="modal-dialog modal-dialog-centered modal-dialog-custom"
    role="document"
  >
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-20 fw-600" id="exampleModalLongTitle">
          Update Email
        </h5>
        <button
          type="button"
          (click)="resetFormData(emailform)"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div *ngIf="errMsg != ''" class="col-md-12 my-2 alert alert-danger">
          {{ errMsg }}
          <button
            type="button"
            (click)="errMsg = ''"
            class="close"
            data-dismiss="alert"
            aria-label="Close"
          >
            <span>&times;</span>
          </button>
        </div>
        <form
          #emailform="ngForm"
          (ngSubmit)="updateEmailOrPhoneNo('', '', email, emailform)"
          novalidate
        >
          <div class="form-group row">
            <label class="font-16 fw-700 col-sm-2 col-form-label">Email:</label>
            <div class="col-sm-10">
              <input
                type="email"
                [(ngModel)]="email"
                name="email"
                id="email"
                class="form-control email-input"
                pattern="^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9]+([\-\.][a-zA-Z0-9]+)*\.[a-zA-Z]{2,}$"
                required
                NoLeadingWhitespace
                #emailId="ngModel"
              />
              <div
                class="text-danger mt-2"
                *ngIf="emailform.submitted && emailId.invalid"
              >
                <span *ngIf="emailId.errors?.['required']">
                  Please enter Email address.
                </span>
                <span *ngIf="emailId.errors?.['pattern']">
                  Please enter a valid Email address.
                </span>
              </div>
            </div>
          </div>
          <div class="col-12 text-center mt-3">
            <button type="submit" class="btn btn-outline-black">
              Send Code
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<!-----------set-Otp-Modal--------->
<div
  class="modal fade otp-modal"
  id="otpModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalCenterTitle"
  aria-hidden="true"
  data-backdrop="static"
  data-keyboard="false"
>
  <div
    class="modal-dialog modal-dialog-centered modal-dialog-custom"
    role="document"
  >
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-20 fw-600" id="exampleModalLongTitle">
          Update Email
        </h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          (click)="resetFormData(emailVerification)"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div
          *ngIf="activationsent == true"
          class="col-md-12 my-2 alert alert-info"
        >
          Verification Code sent again.
          <button
            type="button"
            (click)="activationsent = false"
            class="close"
            data-dismiss="alert"
            aria-label="Close"
          >
            <span>&times;</span>
          </button>
        </div>
        <p class="font-14 fw-600 text-center">
          Kindly check your email for verification code to update email.
        </p>
        <form
          (ngSubmit)="activationCodeVerify(emailVerification.invalid)"
          #emailVerification="ngForm"
          novalidate
        >
          <label class="font-16 fw-700 text-center col-12 mt-3"
            >Enter the verification code</label
          >
          <div class="col-12 activation-grid form-group mt-1">
            <div
              [ngClass]="{
                'is-invalid':
                  incorrectActCode == true ||
                  (emailVerification.submitted &&
                    (emailVerification.untouched || emailVerification.invalid))
              }"
              *ngFor="
                let item of actCodeArr;
                let index = index;
                trackBy: trackByIndex
              "
            >
              <div class="input-field my-0">
                <input
                  type="text"
                  tabindex="{{ index + 1 }}"
                  id="activationCode{{ index }}"
                  name="actCodee[index]"
                  class="form-control text-center activation-field h-2"
                  maxlength="1"
                  required
                  #act="ngModel"
                  (input)="keytab(this.index, $event, 'input')"
                  (keyup)="keytab(this.index, $event, 'keyup')"
                  (focus)="onFocusEvent($event)"
                  (paste)="onPestCode($event, 'activationCode', 6)"
                  [(ngModel)]="actCodeArr[index]"
                  inputmode="tel"
                />
              </div>
            </div>
            <div class="text-center invalid-feedback">
              <span
                *ngIf="
                  emailVerification.submitted &&
                  (emailVerification.untouched || emailVerification.invalid)
                "
              >
                Please Enter Verifcation Code.
              </span>
              <span *ngIf="incorrectActCode == true">
                Invalid verification Code.
              </span>
            </div>
          </div>
          <div class="col-12 text-center mt-4">
            <button type="submit" class="btn btn-outline-black">Update</button>
            <p class="my-2">
              Didn't receive verification code?<button
                type="button"
                (click)="resendActivationCode(f)"
                class="btn btn-link btn-link-theme"
              >
                Resend now
              </button>
            </p>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<!------------------email-Update-sucessfully-Modal------------------->
<div
  class="modal fade"
  id="emailSucessfully"
  tabindex="-1"
  role="dialog"
  aria-labelledby="emailSucessfully"
  aria-hidden="true"
  data-backdrop="static"
  data-keyboard="false"
>
  <div
    class="modal-dialog modal-dialog-centered modal-dialog-custom"
    role="document"
  >
    <div class="modal-content">
      <div class="modal-body pt-4 px-3">
        <h5 class="font-18 fw-600 mt-3">
          Your email address has been changed successfully. To ensure account
          security, please sign in again with your new email.
        </h5>
        <div class="col-12 text-center mt-4">
          <button
            type="button"
            data-dismiss="modal"
            (click)="logOut()"
            class="btn btn-black"
          >
            Ok
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Name Setting Modal -->
<!-- <div class="modal fade" id="namePrefModal" tabindex="-1">
  <div class="modal-dialog">
    <div class="modal-content p-3">
      <div class="modal-header">
        <h5 class="modal-title">Name Display Preference</h5>
      </div>

      <div class="modal-body">
        <p>Please select how you wish to show your public name:</p>

        <div class="form-group mb-2">
          <label>First Name:</label>
  
          <select class="form-control" [(ngModel)]="nameSettingDTO.nameDisplayPreference.firstName"
            (change)="generatePreview()" [disabled]="nameSettingDTO.nameDisplayPreference.keepAsIs" name="nameSettingDTO.nameDisplayPreference.firstName">
            <option value="full">Full</option>
            <option value="initial">Initial</option>
            <option value="hide">Hide</option>
          </select>
        </div>

        <div *ngIf="fullName.middleName" class="form-group mb-2">
          <label>Middle Name:</label>
          <select class="form-control" [(ngModel)]="nameSettingDTO.nameDisplayPreference.middleName"
            (change)="generatePreview()" [disabled]="nameSettingDTO.nameDisplayPreference.keepAsIs" name="nameSettingDTO.nameDisplayPreference.middleName">
            <option value="full">Full</option>
            <option value="initial">Initial</option>
            <option value="hide">Hide</option>
          </select>
        </div>

        <div class="form-group mb-2">
          <label>Last Name:</label>
          <select class="form-control" [(ngModel)]="nameSettingDTO.nameDisplayPreference.lastName"
            (change)="generatePreview()" [disabled]="nameSettingDTO.nameDisplayPreference.keepAsIs" name="nameSettingDTO.nameDisplayPreference.lastName">
            <option value="full">Full</option>
            <option value="initial">Initial</option>
            <option value="hide">Hide</option>
          </select>
        </div>

        <div class="form-check mb-3">
          <input class="form-check-input" type="checkbox" id="keepAsIs"
            [(ngModel)]="nameSettingDTO.nameDisplayPreference.keepAsIs" (change)="onKeepAsIsChange($event)" name="nameSettingDTO.nameDisplayPreference.keepAsIs">
          <label class="form-check-label" for="keepAsIs">Keep it as it is</label>
        </div>

        <div class="alert alert-info">
          <strong>Preview:</strong> {{ previewName }}
        </div>
      </div>

      <div class="modal-footer">
        <button class="btn btn-secondary" data-dismiss="modal" (click)="fetchNameSetting()">Cancel</button>
        <button class="btn btn-primary" (click)="updateNameSetting()">Save</button>
      </div>
    </div>
  </div>
</div> -->
<div
  class="modal fade"
  id="namePrefModal"
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
  data-backdrop="static"
  data-keyboard="false"
>
  <div
    class="modal-dialog modal-dialog-centered modal-dialog-custom name-setting-modal"
    role="document"
  >
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title fw-600 font-20" id="exampleModalLongTitle">
          Name Setting
        </h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          (click)="closeNameSettingPopup()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div
          class="col-md-12 my-2 alert alert-danger"
          *ngIf="errorMessage != ''"
        >
          {{ errorMessage }}
          <button
            type="button"
            class="close"
            data-dismiss="alert"
            aria-label="Close"
          >
            <span>&times;</span>
          </button>
        </div>
        <p class="col-12 font-18 fw-600">
          Please select how you wish to show your public name:
        </p>
        <form class="square-form">
          <div
            class="col-12 mt-3"
            *ngIf="fullName.prefix && nameSettingDTO?.nameDisplayPreference"
          >
            <label class="font-14 fw-600">Prefix:</label>
            <select
              class="form-control select-input"
              [(ngModel)]="nameSettingDTO.nameDisplayPreference.prefix"
              (change)="generatePreview()"
              name="nameSettingDTO.nameDisplayPreference.prefix"
            >
              <option value="full">Full</option>
              <option value="hide">Hide</option>
            </select>
          </div>
          <div
            class="col-12 mt-3"
            *ngIf="nameSettingDTO?.nameDisplayPreference"
          >
            <label class="font-14 fw-600">First Name:</label>
            <select
              class="form-control select-input pointer"
              [(ngModel)]="nameSettingDTO.nameDisplayPreference.firstName"
              (change)="generatePreview()"
              [disabled]="nameSettingDTO.nameDisplayPreference.keepAsIs"
              name="firstNamePref"
            >
              <option value="full">Full</option>
              <option value="initial">Initial</option>
              <option value="hide" *ngIf="fullName.middleName">Hide</option>
              <option value="custom">Custom</option>
            </select>
          </div>
          <div class="col-12 mt-3">
            <input
              *ngIf="
                nameSettingDTO?.nameDisplayPreference?.firstName === 'custom'
              "
              type="text"
              class="form-control mt-2 custom-input"
              name="customFirstName"
              placeholder="Enter custom first name"
              [(ngModel)]="nameSettingDTO.nameDisplayPreference.customFirstName"
              (input)="generatePreview()"
            />
          </div>

          <div
            class="col-12 mt-3"
            *ngIf="fullName.middleName && nameSettingDTO?.nameDisplayPreference"
          >
            <label class="font-14 fw-600">Middle Name:</label>
            <select
              class="form-control select-input pointer"
              [(ngModel)]="nameSettingDTO.nameDisplayPreference.middleName"
              (change)="generatePreview()"
              [disabled]="nameSettingDTO.nameDisplayPreference.keepAsIs"
              name="middleNamePref"
            >
              <option value="full">Full</option>
              <option value="initial">Initial</option>
              <option value="hide">Hide</option>
              <option value="custom">Custom</option>
            </select>
          </div>
          <div class="col-12 mt-3">
            <input
              *ngIf="
                nameSettingDTO?.nameDisplayPreference?.middleName === 'custom'
              "
              type="text"
              class="form-control mt-2 custom-input"
              name="customMiddleName"
              placeholder="Enter custom middle name"
              [(ngModel)]="
                nameSettingDTO.nameDisplayPreference.customMiddleName
              "
              (input)="generatePreview()"
            />
          </div>

          <div
            class="col-12 mt-3"
            *ngIf="nameSettingDTO?.nameDisplayPreference"
          >
            <label class="font-14 fw-600">Last Name:</label>
            <select
              class="form-control select-input pointer"
              [(ngModel)]="nameSettingDTO.nameDisplayPreference.lastName"
              (change)="generatePreview()"
              [disabled]="nameSettingDTO.nameDisplayPreference.keepAsIs"
              name="lastNamePref"
            >
              <option value="full">Full</option>
              <option value="initial">Initial</option>
              <option value="hide" *ngIf="fullName.middleName">Hide</option>
              <option value="custom">Custom</option>
            </select>
          </div>
          <div class="col-12 mt-3">
            <input
              *ngIf="
                nameSettingDTO?.nameDisplayPreference?.lastName === 'custom'
              "
              type="text"
              class="form-control mt-2 custom-input"
              name="customLastName"
              placeholder="Enter custom last name"
              [(ngModel)]="nameSettingDTO.nameDisplayPreference.customLastName"
              (input)="generatePreview()"
            />
          </div>

          <div
            class="col-12 mt-3"
            *ngIf="fullName.suffix && nameSettingDTO?.nameDisplayPreference"
          >
            <label class="font-14 fw-600">Suffix:</label>
            <select
              class="form-control select-input"
              [(ngModel)]="nameSettingDTO.nameDisplayPreference.suffix"
              (change)="generatePreview()"
              name="nameSettingDTO.nameDisplayPreference.suffix"
            >
              <option value="full">Full</option>
              <option value="hide">Hide</option>
            </select>
          </div>
          <div
            class="form-group mt-0 col-12 mt-3"
            *ngIf="nameSettingDTO?.nameDisplayPreference"
          >
            <div class="checkbox">
              <input
                class="form-check-input"
                type="checkbox"
                id="keepAsIs"
                name="keepAsIs"
                [(ngModel)]="nameSettingDTO.nameDisplayPreference.keepAsIs"
                (change)="onKeepAsIsChange($event)"
              />
              <label for="keepAsIs" class="checkbox-label font-14 fw-600"
                >Keep it as it is</label
              >
            </div>
          </div>
          <div class="col-12 mt-3">
            <div class="preview-msg">
              <strong>Preview:</strong> {{ previewName }}
            </div>
          </div>
          <div class="col-12 mt-3 text-right">
            <button
              class="btn btn-outline-black"
              data-dismiss="modal"
              (click)="closeNameSettingPopup()"
            >
              Cancel
            </button>
            <button
              class="btn btn-black ml-3"
              [disabled]="disable"
              (click)="updateNameSetting()"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<!---------------Virtual-event-Modal---------------->
<!-- <div class="modal fade" id="virtualEventModal" tabindex="-1" role="dialog"
  aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-dialog-centered modal-dialog-custom" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title fw-600 font-20" >Virtual Event Settings</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body pt-4 px-3">
         <form>
            <div class="col-12 px-0 d-flex" *ngIf="user">
              <label class="switch">
                <input type="checkbox" [(ngModel)]="user.isSubscribedToVirtualEvents" (ngModelChange)="virtualEventNotification($event)"
                  name="notifyToggle">
                <span class="slider round"></span>
              </label>
              <p class="font-16 fw-600 ml-3">Notify me for all virtual events</p>
            </div>
        </form>
      </div>
    </div>
  </div>
</div> -->
<!-- Event has not started modal -->
<div
  class="modal fade"
  id="eventNotStartedModal"
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
>
  <div
    class="modal-dialog modal-dialog-custom modal-dialog-centered modal-sm"
    role="document"
  >
    <div class="modal-content">
      <div class="modal-body">
        <h1 class="text-center theme-color">
          <i class="fi flaticon-information font-40"></i>
        </h1>
        <h6 class="text-center bold my-3 theme-color">Sorry !</h6>
        <p class="text-center theme-color">The event has not started yet</p>
        <div class="col-12 text-center">
          <button
            type="button"
            class="btn btn-black mt-4 mb-2 mx-2 py-1 font-12"
            data-dismiss="modal"
          >
            Ok
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Claim Approved Modal -->
<div
  class="modal fade"
  id="claimApprovedModal"
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
  data-backdrop="static"
  data-keyboard="false"
>
  <div
    class="modal-dialog modal-dialog-custom modal-dialog-centered modal-sm"
    role="document"
  >
    <div class="modal-content">
      <div class="modal-body">
        <h1 class="text-center text-success">
          <i class="fi flaticon-shield-success font-40"></i>
        </h1>
        <h6 class="text-center bold my-3 theme-color">Congratulations!</h6>
        <p class="text-center theme-color">
          Your claim request has been approved.
        </p>
        <div class="col-12 text-center">
          <button
            type="button"
            class="btn btn-black mt-4 mb-2 mx-2 py-1 font-12"
            data-dismiss="modal"
            (click)="approvedOk()"
          >
            Ok
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Claim Rejected Modal -->
<div
  class="modal fade"
  id="claimRejectedModal"
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
  data-backdrop="static"
  data-keyboard="false"
>
  <div
    class="modal-dialog modal-dialog-custom modal-dialog-centered modal-sm"
    role="document"
  >
    <div class="modal-content">
      <div class="modal-body">
        <h1 class="text-center text-danger">
          <i class="fi flaticon-shield-failed font-40"></i>
        </h1>
        <h6 class="text-center bold my-3 theme-color">Request Rejected</h6>
        <p class="text-center theme-color">
          Your claim request has been rejected.
        </p>
        <div class="col-12 text-center">
          <button
            type="button"
            class="btn btn-black mt-4 mb-2 mx-2 py-1 font-12"
            data-dismiss="modal"
            (click)="rejectedOk()"
          >
            Create your page
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
